import { useDispatch } from 'react-redux';
import { Fragment, useEffect, useState } from 'react';
import moment from 'moment/moment';
import { Link } from 'react-router';
import { getProjectsWithGiverInfo } from '../../../organization-actions';
import { getGiverdataTableQueryString } from '../../../organization-model';
import ButtonText from '../../../../components/button/button-text/ButtonText';
import VisibleIf from '../../../../components/VisibleIf';
import styles from './giverdata-project-list.module.less';

export const GiverdataProjectList = ({ organizationId }) => {
    const dispatch = useDispatch();
    const pageSize = 6;
    const [projects, setProjects] = useState([]);
    const [page, setPage] = useState(0);
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (organizationId) {
            dispatch(getProjectsWithGiverInfo({ organizationId, max: pageSize, page })).then((data) => {
                setProjects(data.body.projects);
                setCount(data.body.count);
            });
        }
    }, [organizationId, page, dispatch, pageSize]);

    const downloadCSV = ({ projectId, organizationId, dataType }) => {
        const element = document.createElement('a');
        const query = getGiverdataTableQueryString({ dataType, projectId });
        const url = `/api/private/organization/${organizationId}/givers.csv?${query}&excel=true`;
        element.setAttribute('href', url);
        const currentDateString = moment().format('YYYY-MM-DD');
        element.setAttribute(
            'download',
            projectId
                ? `spleis-prosjekt-${projectId}-giverdata-${currentDateString}.csv`
                : `spleis-all-giverdata-${currentDateString}.csv`
        );
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
    };

    const endingText = (p) => {
        const endDate = moment(p.ends_at).format('DD.MM.YYYY');
        if (moment(p.ends_at).isAfter(moment())) {
            return `Avsluttes: ${endDate}`;
        }
        if (p.payout_at) {
            return `Utbetalt: ${moment(p.payout_at).format('DD.MM.YYYY')}`;
        }
        return `Avsluttet: ${endDate}`;
    };

    const mappedProjects = projects.map((p) => {
        const projectTitle = p.title.length > 40 ? `${p.title.substring(0, 40)}…` : p.title;
        return (
            <Fragment key={p.id}>
                <div key={p.id} className={styles.project}>
                    <div className={styles.projectTitle}>
                        <Link to={`/project/${p.id}`} target={'_blank'}>
                            {projectTitle}
                        </Link>
                    </div>
                    <div className={styles.endDate} suppressHydrationWarning>
                        {endingText(p)}
                    </div>
                    <div>
                        <strong> Totalt antall innbetalinger: </strong>
                        {p.giverdata_count}
                    </div>
                    <ButtonText
                        className={styles.downloadButton}
                        onClick={() => downloadCSV({ projectId: p.id, organizationId })}
                    >
                        Last ned alle transaksjoner
                    </ButtonText>
                    <div>
                        <strong>Antall innbetalinger med giverdata: </strong>
                        {p.giverdata_data_count}
                    </div>
                    {p.giverdata_data_count > 0 ? (
                        <ButtonText
                            className={styles.downloadButton}
                            onClick={() => downloadCSV({ projectId: p.id, organizationId, dataType: 'giverData' })}
                        >
                            Last ned giverdata
                        </ButtonText>
                    ) : (
                        <span className={styles.noDownload}>Ingen givere har delt giverdata enda</span>
                    )}
                    <div>
                        <strong> Antall innbetalinger med skattefradrag: </strong>
                        {p.giverdata_taxrefund_count}
                    </div>
                    {p.giverdata_taxrefund_count > 0 && p.payout_at ? (
                        <ButtonText
                            className={styles.downloadButton}
                            onClick={() => downloadCSV({ projectId: p.id, organizationId, dataType: 'taxRefund' })}
                        >
                            Last ned skattefradrag
                        </ButtonText>
                    ) : p.giverdata_taxrefund_count > 0 ? (
                        <span className={styles.noDownload}>Nedlasting blir tilgjengelig når spleisen er utbetalt</span>
                    ) : (
                        <span className={styles.noDownload}>Ingen givere har bedt om skattefradrag enda</span>
                    )}
                </div>
            </Fragment>
        );
    });

    return (
        <>
            <div>{mappedProjects}</div>
            <div className={styles.prProjectNavigationButtons}>
                <VisibleIf isVisible={page !== 0}>
                    <ButtonText onClick={() => setPage(page - 1)}>Forrige</ButtonText>
                </VisibleIf>
                <VisibleIf isVisible={count > page * pageSize + pageSize}>
                    <ButtonText onClick={() => setPage(page + 1)}>Neste</ButtonText>
                </VisibleIf>
            </div>
        </>
    );
};
